"use strict";

angular.module('app').filter('translateDate', function (selectedLanguage) {
    return function (input, format) {
        return input ? moment(input).locale(selectedLanguage).format(format || 'll') : '-';
    };
});